import { PACKAGES_ACTIONS } from "./PACKAGES_ACTIONS"


export function packagesReducer(state, action) {
  switch (action.type) {
    case PACKAGES_ACTIONS.SET_PACKAGES:
      return {
        ...state,
        packages: action.payload.packages,
        pagination: action.payload.pagination,
      }
    case PACKAGES_ACTIONS.SET_IS_LOADING:
      return { ...state, isLoading: action.payload.isLoading }
    default:
      return state
  }
}